export default function parseJSONP(jsonp) {
    const f = new Function("callback", jsonp);
    let data;
    f((callback) => (data = callback));
  
    return data;
  }